import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('ck_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401 && !window.location.pathname.includes('/login')) {
      localStorage.removeItem('ck_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const errText = (e) => {
  const m = e?.response?.data?.message;
  if (Array.isArray(m)) return m.join(', ');
  return m || e?.message || 'Что-то пошло не так';
};

export default api;

const get = (url, params) => api.get(url, { params }).then((r) => r.data);
const post = (url, data) => api.post(url, data).then((r) => r.data);
const patch = (url, data) => api.patch(url, data).then((r) => r.data);

export const authApi = {
  telegram: (initData) => post('/auth/telegram', { initData }),
  devLogin: (userId) => post('/auth/dev-login', { userId }),
  devUsers: () => get('/auth/dev-users'),
  me: () => get('/auth/me'),
  updateMe: (data) => patch('/auth/me', data),
};

export const menuApi = {
  public: () => get('/menu'),
  my: () => get('/menu/my'),
  dish: (id) => get(`/menu/dish/${id}`),
  favorites: () => get('/menu/favorites'),
  toggleFavorite: (dishId) => post(`/menu/favorites/${dishId}`),
  addReview: (data) => post('/menu/reviews', data),
};

export const ordersApi = {
  calculate: (data) => post('/orders/calculate', data),
  create: (data) => post('/orders', data),
  my: () => get('/orders'),
  one: (id) => get(`/orders/${id}`),
  cancel: (id, reason) => patch(`/orders/${id}/cancel`, { reason }),
  timeSlots: (date) => get('/orders/time-slots', { date }),
};

export const packagesApi = {
  list: () => get('/packages'),
  one: (id) => get(`/packages/${id}`),
  my: () => get('/packages/my'),
  subscribe: (data) => post('/packages/subscribe', data),
  pause: (id) => patch(`/packages/subscriptions/${id}/pause`),
  resume: (id) => patch(`/packages/subscriptions/${id}/resume`),
};

export const profileApi = {
  cashback: () => get('/profile/cashback'),
  nutrition: (days = 7) => get('/profile/nutrition', { days }),
  savings: (days = 30) => get('/profile/savings', { days }),
};

export const notificationsApi = {
  list: () => get('/notifications'),
  unreadCount: () => get('/notifications/unread-count'),
  readAll: () => post('/notifications/read'),
};

export const paymentsApi = {
  create: (data) => post('/payments/create', data),
  confirm: (id) => post(`/payments/${id}/confirm`),
  my: () => get('/payments/my'),
};
